import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "10", y1: "4", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "5", y1: "20", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "9", y1: "4", y2: "20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Italic";
const Italic = memo(themed(Icon));
export {
  Italic
};
//# sourceMappingURL=italic.js.map
